module.exports = {
    DEVELOPMENT: 'development',
    PRODUCTION: 'production',
    TEST: 'test'
};
